import React, { memo, useEffect, useState } from "react";
import tw from "twin.macro";
import { ECommerce } from "../api/AppConfigApi";
import toast from "react-hot-toast";
import upiTB from "../../src/images/Thanshiq/diamond mainpage/upi-icon.png"
import cash from "../../src/images/Thanshiq/diamond mainpage/rupee-note-icon.png"
import netB from "../../src/images/Thanshiq/diamond mainpage/bank-deposit-icon.png"
import emi from "../../src/images/Thanshiq/diamond mainpage/calculator-money-icon.png"
import gpay from "../../src/images/Thanshiq/diamond mainpage/jp_googlepay.png"
import paytm from "../../src/images/Thanshiq/diamond mainpage/jp_paytm.png"
import phonepe from "../../src/images/Thanshiq/diamond mainpage/jp_phonepe.png"
import { Image } from "react-bootstrap";
import netBP from "../../src/images/Thanshiq/diamond mainpage/NetBP.svg"
import upiBP from "../../src/images/Thanshiq/diamond mainpage/UPIP.png"
import { usePaymentInputs } from 'react-payment-inputs';
import cred from "../../src/images/Thanshiq/diamond mainpage/CRED.png"
import amap from "../../src/images/Thanshiq/diamond mainpage/jp_amazonpay.png"
import upih from "../../src/images/Thanshiq/diamond mainpage/upiP.svg"
import sbi from "../../src/images/Thanshiq/diamond mainpage/SBI_bank_508548.png"
import hdfc from "../../src/images/Thanshiq/diamond mainpage/hdfc bank_607152.png"
import Icici from "../../src/images/Thanshiq/diamond mainpage/icici_bank_508534.png"
import axis from "../../src/images/Thanshiq/diamond mainpage/axix_bank_607153.png"

//eslint-disable-next-line
const Heading = tw.h1`text-black`;

function ChoosePaymentMethod({ Loading, OrderStatus, createSaleItems }) {

  const [paymentModeLabel, setPaymentModeLabel] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [selectedMethod, setSelectPaymentMethod] = useState("debit");

  const [upiId, setUpiId] = useState('');
  const [qrCode, setQrCode] = useState('');
  const [paymentAmount, setPaymentAmount] = useState(10); // Replace with actual payment amount

  const generateQRCode = (event) => {
    event.preventDefault();
    const upiUrl = `upi://pay?pa=your-merchant-upi-id@bank&pn=Your%20Name&am=${paymentAmount}&cu=INR`;
    setQrCode(upiUrl);
  };

  // const handleUPIPayment = (event) => {
  //   event.preventDefault();
  //   // Initiate payment request using the UPI ID
  //   const paymentUrl = `upi://pay?pa=${upiId}&pn=Your%20Name&am=${paymentAmount}&cu=INR`;
  //   window.location.href = paymentUrl;
  // };

  const handleUPIPayment = (event) => {
    event.preventDefault();
    if (!upiId) {
      toast.error("Please enter a valid UPI ID");
      return;
    }
    try {
      const paymentUrl = `upi://pay?pa=${upiId}&pn=Your%20Name&am=${paymentAmount}&cu=INR&tn=Payment%20for%20order`;
      window.location.href = paymentUrl;
    } catch (error) {
      console.error(error);
      toast.error("Error initiating payment");
    }
  };

  useEffect(() => {
    getPaymentConfigurationData();
    //eslint-disable-next-line
  }, [])

  const getPaymentConfigurationData = async () => {
    const appConfigResData = await ECommerce("pg_endpoint_config");
    const abcd = JSON.parse(appConfigResData.response.moduleField);
    // const paymentModes = []
    // Object.entries(abcd.paymentConfMap.Rasi).forEach((item)=>{
    //   paymentModes.push(item[0])
    // })
    const  branchName = localStorage.getItem("branchName");
    const paymentModes = Object.keys(abcd.paymentConfMap[branchName]).filter(item => item === "PAYU");

    console.log(paymentModes, 'paymentModes')
    setPaymentModeLabel(paymentModes)
  }

  const onRadioChange = (event) => {
    setSelectedPaymentMethod(event.target.value);
  };

  const onCheckboxChange = (event) => {
    setAgreeTerms(event.target.checked);
  };

  // const validateForm = () => {
  //   return selectedPaymentMethod !== "" && agreeTerms;
  // };

  const onSubmitForm = (event) => {
    if (selectedPaymentMethod === "" && agreeTerms === false) {
      toast.error("please Select Payment Method And Terms And Condition")
    }
    else if (selectedPaymentMethod === "") {
      toast.error("please Select Payment Method");
    }
    else if (agreeTerms === false) {
      toast.error("Please Select Terms And Condition");
    }
    else {
      event.preventDefault();
      OrderStatus();
    }
  };

  // const onSubmitForm = async (event) => {
  //   event.preventDefault();

  //   if (selectedPaymentMethod === "" && agreeTerms === false) {
  //     toast.error("please Select Payment Method And Terms And Condition");
  //   } else if (selectedPaymentMethod === "") {
  //     toast.error("please Select Payment Method");
  //   } else if (agreeTerms === false) {
  //     toast.error("Please Select Terms And Condition");
  //   } else {
  //     try {
  //       const res = await fetch('http://localhost:5000/api/initiate-payment', {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ amount: total })
  //       });

  //       const { encRequest, accessCode, actionUrl } = await res.json();

  //       const form = document.createElement('form');
  //       form.method = 'POST';
  //       form.action = actionUrl;

  //       const inputEnc = document.createElement('input');
  //       inputEnc.name = 'encRequest';
  //       inputEnc.value = encRequest;
  //       inputEnc.type = 'hidden';

  //       const inputAccess = document.createElement('input');
  //       inputAccess.name = 'access_code';
  //       inputAccess.value = accessCode;
  //       inputAccess.type = 'hidden';

  //       form.appendChild(inputEnc);
  //       form.appendChild(inputAccess);
  //       document.body.appendChild(form);
  //       form.submit();
  //     } catch (error) {
  //       console.error(error);
  //       toast.error("Payment initiation failed.");
  //     }
  //   }
  // };


  const [validation, setValidation] = useState(true);
  const [total, setTotal] = useState([]);
  const calcTotal = (cartList) => {
    setValidation(true);
    let totalCartValue = 0;
    cartList &&
      cartList.forEach((data) => {
        if (data.total > 0) {
          totalCartValue += data.total;
        }
      });
    const isSoldProductAvailable =
      cartList.length > 0 &&
      cartList.some((data) => data.statusName?.toLowerCase() === "sold");
    if (isSoldProductAvailable) setValidation(false);
    setTotal(totalCartValue);
  };
  const { meta, getCardNumberProps, getExpiryDateProps, getCVCProps } = usePaymentInputs();

  return (
    <form className="needs-validation">
      <div className="row">
        <span className="d-flex justify-content-end">Amount</span>
        <b>Order Amount</b>
        {/* <span className="d-flex justify-content-end">
          <span className="totalStyle">₹{Math.trunc(total).toString()} </span>
        </span> */}
        <div
          className="form-check"
          tw="sm:mx-20 sm:my-10 m-5"
        // style={{ margin: " 30px 51px" }}
        >
          {paymentModeLabel.map((item, index) => (
            <div key={index}>
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id={`flexRadioDefault${index}`}
                value={item}
                checked={selectedPaymentMethod === item}
                onChange={onRadioChange}
              />
              <label className="form-check-label" htmlFor={`flexRadioDefault${index}`}>
                {item === "PAYU" && item}
              </label>
            </div>
          ))}
        </div>



        {/* <div style={{width:"400px",height:"160px",border:"1px solid gray",borderRadius:"10px",marginLeft:"33px"}}>
<header className="h6"> UPI APPS</header>
<div className="d-flex p-2 " style={{borderBottom:"1px solid gray"}}>
<input class="form-check-input " type="radio" name="exampleRadios" id="exampleRadios1" value="option1" />
  <label class="form-check-label " for="Emi">
  Gpay    
    </label>
    <img src={gpay} style={{width:"20px",height:"25px"}} />
</div>
   

    <div className="d-flex p-2" style={{borderBottom:"1px solid gray"}}>
      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="option2" />
      <label>PhonePe </label>
      <img src={phonepe} style={{width:"20px",height:"25px"}} />
    </div>

      <div className="d-flex p-2">
      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" value="option3" />
      <label>Paytm</label>
      <img src={paytm} style={{width:"40px",height:"30px"}} />
      </div>
   
   
    </div> */}
        {/* <div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="option2" />
  <label class="form-check-label" for="exampleRadios2">
    PhonePe
  </label>
</div>

<div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" value="option3" />
  <label class="form-check-label" for="exampleRadios3">
    Paytm
  </label>
</div> */}


        {/*         
        <div  style={{marginLeft:"30px",marginTop:"10px"}}>
  <h6>
    CREDIT & DEBIT CARDS
  </h6>
  <button className="" style={{border:"1px solid gray",width:"400px"}}>
  <i class="bi bi-plus-lg"></i> Add a new credit or debit card
  </button>
</div>
<div style={{marginLeft:"30px",marginTop:"10px"}}>
  <h6>MORE WAYS TO PAY</h6>

  <div style={{width:"400px",height:"160px",border:"1px solid gray",borderRadius:"10px"}}>
    <div className="p-2" style={{borderBottom:"1px solid gray"}}>
    <input class="form-check-input " type="radio" name="exampleRadios" id="exampleRadios1" value="option1" />
  <label class="form-check-label " for="Emi">
    EMI
    </label>
    <img src={emi} style={{width:"40px",height:"30px"}} />
    </div>
  <div className="p-2" style={{borderBottom:"1px solid gray"}}>
  <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" />
    Net Banking
    <img src={netB} style={{width:"40px",height:"30px"}} />
  </div>
    
    <div className="p-2" >
    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="option2" />
    Cash on Delivery / Pay on Delivery <img src={cash} style={{width:"40px",height:"30px"}} /><br />
    <small style={{marginLeft:"10px"}}>Cash,Upi and Cards accepted</small>
   
    </div>
  
  
    </div>
    
</div>  */}
        <div className="form-check py-2 " tw="text-sm">
          <input
            className="form-check-input mx-sm-2 mx-sm-1"
            type="checkbox"
            name="flexRadioDefault"
            id="flexRadioDefault1"
            checked={agreeTerms}
            onChange={onCheckboxChange}
          />
          <label
            className="form-check-label text-xs"
            htmlFor="flexRadioDefault1"
          >
            I Agree with the
            <a href="/TermsConditions" target="_blanck" rel="noreferrer" style={{ textDecoration: "none" }}>
              Terms & Conditions
            </a>
          </label>
        </div>
        <hr className="mb-3" />
        <div className="text-center">
          <button
            className="btn-md hoverEffect px-3 py-2 rounded "
            // onClick={createSaleItems}
            onClick={onSubmitForm}
            // disabled={!validateForm() || Loading}
            type="button"
          >
            {Loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></span>
                <span className="mx-2">Loading . . .</span>
              </>
            ) : (
              <>
                <i
                  className="bi bi-credit-card-2-front"
                  tw="px-3 text-base"
                ></i>
                Proceed to Pay
              </>
            )}
          </button>
        </div>

      </div>

    </form>
  );
}

export default memo(ChoosePaymentMethod)